var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.167673 6.875C0.40327 7.28307 0.834208 7.50805 1.27418 7.5H18.7258C19.1658 7.50805 19.5967 7.28307 19.8323 6.875C20.1775 6.27713 19.9727 5.51265 19.3748 5.16747C18.9762 4.93735 15.8513 3.21486 10 0C4.1487 3.21486 1.02376 4.93735 0.625196 5.16747C0.0273424 5.51265 -0.177497 6.27713 0.167673 6.875Z",
    fill: "#8792A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 9.375V17.5H11.875V9.375H8.125V17.5H6.25V9.375H2.5V17.5H1.00021C0.447924 17.5 0.00020871 17.9477 0.00020871 18.5V20H19.9998V18.5C19.9998 17.9477 19.5521 17.5 18.9998 17.5H17.5V9.375H13.75Z",
    fill: "#8792A2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.d01d28d352e2c88fc89366dca30303cd.svg";
export { ForwardRef as ReactComponent };